var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoneLocationCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49883 11.5952C5.59388 10.4213 2.0064 7.17777 2.89607 3.59441C3.20498 2.31758 4.71864 -0.186653 8.302 0.0110501C9.63031 0.175804 12.528 1.33937 12.5959 4.45937C12.6267 5.88035 12.2252 8.4752 7.49883 11.5952ZM7.59149 7.02339C8.8028 7.02339 9.78476 6.04143 9.78476 4.83012C9.78476 3.61882 8.8028 2.63686 7.59149 2.63686C6.38019 2.63686 5.39823 3.61882 5.39823 4.83012C5.39823 6.04143 6.38019 7.02339 7.59149 7.02339Z",
    fill: "#F46767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4521 9.83447C2.05171 10.0404 0.0217675 10.621 1.53685 12.4293C3.4521 14.7153 12.7812 14.4681 14.2022 11.9351C14.2949 11.5335 14.4802 10.5141 11.5147 10.0198",
    stroke: "#69ADFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneLocationCircle);
export default __webpack_public_path__ + "static/media/zone-location-circle.6f9afddd0f4301be68c592f645a2efc4.svg";
export { ForwardRef as ReactComponent };